import { render, staticRenderFns } from "./shieldCheckIcon.vue?vue&type=template&id=8b7097e4&"
import script from "./shieldCheckIcon.vue?vue&type=script&lang=js&"
export * from "./shieldCheckIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports